export default "__VITE_ASSET__D1QG4SS4__"